import { BrowserRouter, useLocation } from 'react-router-dom';
import './App.css';
import { useEffect, useState } from 'react';
import { Theme } from './themes';
import ThemeRoutes from './routes';
import { useDispatch, useSelector } from 'react-redux';
import { setDataTheme } from './context/themeSlice';
import { getCookie } from './utils';
import { login } from './context/authenticationSlice';

function App() {
  const customization = useSelector((state) => state.customization);
  const location = useLocation();
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  const dispatch = useDispatch();

  useEffect(() => {
    const verificarSeTemThema = localStorage.getItem("theme");
    if (verificarSeTemThema == null) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
      dispatch(setDataTheme({ theme: "dark" }));
      setDarkMode(true);
      return;
    }

    if (darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
      dispatch(setDataTheme({ theme: "dark" }));
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
      dispatch(setDataTheme({ theme: "light" }));
    }
  }, [darkMode]);


  useEffect(() => {
    const logado = getCookie("authToken");

    if (logado) {
      dispatch(login(JSON.parse(logado)));
    }
  }, [location]);

  return (
    <Theme customization={customization}>

      <ThemeRoutes />

    </Theme>
  );
}

export default App;
